import { CardElement } from '@stripe/react-stripe-js';
import { action } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import BaseLabel from '../BaseLabel/BaseLabel';
import './PaymentCardForm.scss';
var cardElementOptions = {
    style: {
        base: {
            fontSize: '16px',
            fontFamily: '"DM Sans", sans-serif',
            color: '#424770',
            '::placeholder': {
                color: '#aab7c4',
            },
        },
        invalid: {
            color: '#9e2146',
        },
    },
};
var PaymentCardForm = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        lastEvent: undefined,
        get error() {
            var _a;
            return (_a = s.lastEvent) === null || _a === void 0 ? void 0 : _a.error;
        }
    }); });
    var handleChange = action(function (e) {
        s.lastEvent = e;
        p.onChange && p.onChange(e);
    });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('PaymentCardForm', s.error && 'hasError') },
            React.createElement(BaseLabel, null, "Enter Card Details:"),
            React.createElement(CardElement, { options: cardElementOptions, onChange: handleChange }))); } });
};
export default PaymentCardForm;
